// A list on the glass: rows of one height, each with a lead (an icon, a
// rank, or nothing), a name, and a value at the right edge. The vote, the
// night's standings and the board are all this. A row with `onPress` is a
// button; a picked row wears the llama's colour down its left edge.

import { el } from './dom';

export interface ListRow {
  // What leads the row: an element (an icon), a short string (a rank), or
  // nothing.
  lead?: HTMLElement | string | undefined;
  name: string;
  value?: string | undefined;
  picked?: boolean | undefined;
  // The viewer's own row.
  mine?: boolean | undefined;
  onPress?: (() => void) | undefined;
}

export function list(rows: ListRow[], className = ''): HTMLElement {
  const box = el('div', `list ${className}`.trim());
  for (const row of rows) box.append(item(row));
  return box;
}

function item(row: ListRow): HTMLElement {
  const classes = ['item'];
  if (row.picked) classes.push('is-picked');
  if (row.mine) classes.push('is-mine');
  const node = row.onPress
    ? (document.createElement('button') as HTMLElement)
    : document.createElement('div');
  node.className = classes.join(' ');
  const lead = el('span', 'item-lead');
  if (typeof row.lead === 'string') lead.textContent = row.lead;
  else if (row.lead) lead.append(row.lead);
  const name = el('span', 'item-name');
  name.textContent = row.name;
  const value = el('span', 'item-value');
  value.textContent = row.value ?? '';
  node.append(lead, name, value);
  if (row.onPress) {
    const press = row.onPress;
    node.addEventListener('click', press);
  }
  return node;
}
